/* unplugin-vue-components disabled */import { render } from "./PosConfiguration.vue?vue&type=template&id=3ac85eb0&ts=true"
import script from "./PosConfiguration.vue?vue&type=script&lang=ts"
export * from "./PosConfiguration.vue?vue&type=script&lang=ts"

import "./PosConfiguration.vue?vue&type=style&index=0&id=3ac85eb0&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__